export default __webpack_public_path__ + "static/media/rune-card.7ec7c453.png";